import { WorkflowTaskToCreateDto } from './workflow-task-to-create-dto.interface';

export interface workflowSectionsToCreateDto {
    name: string;
    workflowTasks: WorkflowTaskToCreateDto[];
}
